import ColorSectionTextQuote from './color-section-text-quote';
export default ColorSectionTextQuote;
